// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HideCollectibleModal_wrapper__1lDVO","content":"HideCollectibleModal_content__1jHY_"};